module.exports = __webpack_public_path__ + "img/menuboard-cho-express.b00e0123.webp";